import {Trans} from '@lingui/macro';
import {
  Button,
  CircularProgress,
  Container,
  CssBaseline,
  Link,
  makeStyles,
  Snackbar,
  TextField,
  Typography,
} from '@material-ui/core';
import {TABLETCOURSE} from 'features/capacitation/component/actions';
import {validateInstructor} from 'features/capacitation/hookos/hooks';
import {i18n2} from 'features/i18n/i18n';
import {logout} from 'features/login/actions';
import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Redirect} from 'react-router-dom';
import useUser from '../../components/GenericsHooks/useUser';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  logo: {
    height: 'auto',
    width: 'auto',
    maxHeight: '36px',
    verticalAlign: 'middle',
  },
  message: {
    backgroundColor: 'green',
    color: 'white',
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

const ConfirmCredentials = () => {
  const classes = useStyles();
  const [isLoading, setIsLoading] = React.useState(false);
  const [loginFail, setLoginFail] = React.useState(false);
  const [redirectFromTablet, setRedirectFromTablet] = React.useState(false);
  const user = useUser();
  const dispatch = useDispatch();
  const userState = useSelector((state) => state.authentication.user);
  const [credentials, setCredentials] = React.useState({
    username: user,
    password: '',
  });
  const [message, setMessage] = React.useState({
    open: false,
    text: '',
  });
  const handleChange = (e) => {
    let target = e.target;
    setCredentials((prevState) => {
      return {...prevState, [target.name]: target.value};
    });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    if (isLoading && loginFail) {
      setLoginFail(false);
      setIsLoading(false);
    }
  });

  const attemptLogin = () => {
    validateInstructor(
      credentials.username,
      credentials.password,
      userState.token,
    ).then((response) => {
      if (response.ok) {
        dispatch({
          type: TABLETCOURSE,
          payload: {tablet: false, assistants: false},
        });
        setRedirectFromTablet(true);
      } else {
        response.text().then((respMessage) => {
          setMessage({open: true, text: respMessage});
        });
      }
    });
  };

  const signout = () => {
    dispatch({type: TABLETCOURSE, payload: {tablet: false, assistants: false}});
    logout();
  };

  if (redirectFromTablet) {
    return <Redirect to={'/Management'} push />;
  }

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Typography component="h1" variant="h5">
          <Trans>SALIR DEL MODO TABLET</Trans>
        </Typography>
        <form className={classes.form} noValidate>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label={i18n2._('Usuario')}
            name="username"
            value={user}
            disabled
            autoFocus
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label={i18n2._('Password')}
            type="password"
            autoComplete="current-password"
            onChange={(e) => handleChange(e)}
          />
          <Button
            type="button"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            onClick={() => attemptLogin()}
            disabled={isLoading}>
            {isLoading && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
            <Trans>Confirmar credenciales</Trans>
          </Button>
          <Button component={Link} onClick={() => signout()}>
            <Trans>Cerrar sesión</Trans>
          </Button>
        </form>
      </div>
      <Snackbar
        open={message.open}
        autoHideDuration={1000}
        onClose={() => setMessage({...message, open: false})}
        bodystyle={classes.message}
        message={i18n2._(message.text ? message.text : '')}
      />
    </Container>
  );
};

export default ConfirmCredentials;
